/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-restricted-syntax */
import { isValidDate } from "../datetime";

const eq = <T>(a: T, b: T): boolean => a === b;
const lt = <T>(a: T, b: T): boolean => a > b;

const _asc = <T>(a: T, b: T): -1 | 1 => (lt(a, b) ? 1 : -1);
const _desc = <T>(a: T, b: T): -1 | 1 => (lt(a, b) ? -1 : 1);

export const asc = <T>(a: T, b: T): -1 | 0 | 1 => {
    if (eq(a, b)) return 0;
    return _asc(a, b);
};

export const desc = <T>(a: T, b: T): -1 | 0 | 1 => {
    if (eq(a, b)) return 0;
    return _desc(a, b);
};

const eqDate = (a: Date, b: Date): boolean => a.getTime() === b.getTime();

export const ascDate = (a: Date | undefined, b: Date | undefined): -1 | 0 | 1 => {
    const aValid = isValidDate(a);
    const bValid = isValidDate(b);

    if (!aValid && !bValid) return 0; // 両方異常値の場合並び順は変えない
    if (aValid && !bValid) return -1; // bが異常値の場合aを前に
    if (!aValid && bValid) return 1; // aが異常値の場合bを前に

    // ここまでの分岐のしかただと型ガードが効かないので、as Dateで取り扱い
    const _a = a as Date;
    const _b = b as Date;
    if (eqDate(_a, _b)) return 0;
    return _asc(_a.getTime(), _b.getTime());
};

export const descDate = (a: Date | undefined, b: Date | undefined): -1 | 0 | 1 => {
    const aValid = isValidDate(a);
    const bValid = isValidDate(b);

    if (!aValid && !bValid) return 0; // 両方異常値の場合並び順は変えない
    if (aValid && !bValid) return -1; // bが異常値の場合aを前に
    if (!aValid && bValid) return 1; // aが異常値の場合bを前に

    // ここまでの分岐のしかただと型ガードが効かないので、as Dateで取り扱い
    const _a = a as Date;
    const _b = b as Date;
    if (eqDate(_a, _b)) return 0;
    return _desc(_a.getTime(), _b.getTime());
};

type Comparator<T> = (a: T, b: T) => -1 | 0 | 1;

// マルチソートする関数
export const chainedSort = <T>(a: T, b: T, ...sorters: Comparator<T>[]): -1 | 0 | 1 => {
    for (const sorter of sorters || []) {
        // 比較
        const compare = sorter(a, b);

        // 0以外: 異なる値。比較結果をそのまま返す
        // 0: 同値。次の第n+1キーのソートに移る
        if (compare) return compare;
    }

    // 全部すり抜けたら[0:同値]扱い
    return 0;
};
